import styled from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const ParagraphContent = styled.p`
    padding-bottom: 4rem;
    word-break: break-word;

    ${FONT_PROPERTIES}

    ${mediaMaxWidth.medium`
        padding-bottom: 2rem;
    `}

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
